import { LinkInterface } from '../components/navbar/navbar';

const useNavButtons = () => {
  const Buttons: LinkInterface[] = [
    {
      title: 'Assignment Creator',
      link: {
        url: {
          path: '/assignments'
        }
      },
      links: [],
      type: 'primary',
      secondary: true,
      fieldAnalyticsEventName: 'assignmentCreator'
    }
  ];

  const updateButtons = () => {
    return Buttons;
  };
  return [Buttons, updateButtons];
};

export default useNavButtons;
